import { useEffect, useState } from "react";
import { X, ZoomIn } from "lucide-react";

export const ZoomImage = ({ src, alt, className = "", hint = true, ...props }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="relative block w-full group cursor-zoom-in text-left" aria-label={`Agrandir : ${alt}`} data-testid="zoom-image-btn">
        <img src={src} alt={alt} className={className} {...props} />
        {hint && (
          <span className="md:hidden absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-full bg-[#FFFDF9]/90 px-3 py-1 text-xs text-[#78353A] shadow">
            <ZoomIn className="w-3.5 h-3.5" /> Agrandir
          </span>
        )}
      </button>
      {open && (
        <div className="fixed inset-0 z-[100] bg-[#2b1d17]/90 backdrop-blur-sm overflow-auto" onClick={() => setOpen(false)} data-testid="lightbox" style={{ touchAction: "pinch-zoom" }}>
          <button type="button" onClick={() => setOpen(false)} aria-label="Fermer" data-testid="lightbox-close"
            className="fixed top-4 right-4 z-10 w-11 h-11 rounded-full bg-[#FFFDF9] text-[#78353A] flex items-center justify-center shadow-lg">
            <X className="w-5 h-5" />
          </button>
          <p className="md:hidden fixed top-6 left-4 text-xs text-[#FFFDF9]/80">Fais glisser pour explorer ✿</p>
          <div className="min-h-full flex items-start justify-start md:justify-center p-3 pt-16 md:p-10">
            <img src={src} alt={alt} className="w-[175vw] max-w-none md:w-full md:max-w-4xl rounded-2xl shadow-2xl" onClick={(e) => e.stopPropagation()} />
          </div>
        </div>
      )}
    </>
  );
};

export default ZoomImage;
